export default "__VITE_ASSET__0073ab04__"